// extracted by mini-css-extract-plugin
export default {"repair":"System_repair__O4yaj","repair__img":"System_repair__img__4ok12","repair__words":"System_repair__words__sxQ3R"};